module.exports = __webpack_public_path__ + "img/thumb_13.56858718.jpg";